import NotificationsIcon from '@mui/icons-material/Notifications';
import * as React from 'react';

interface Props {
    count: number;
    onClick: () => void;
}
const Notification = (props: Props) => {
    return (
        <div
            className="cursor-pointer"
            style={{
                display: 'flex',
            }}
            onClick={props.onClick}
        >
            <div
                style={{
                    backgroundColor: 'rgb(255, 72, 66)',
                    width: 25,
                    height: 25,
                    borderRadius: '50%',
                    color: '#fff',
                    position: 'relative',
                    top: 0,
                    left: 0,
                }}
            >
                {props.count}
            </div>
            <NotificationsIcon />
        </div>
    );
};

export default Notification;
